<template>
  <div class="section regulatoryAffairs">
    <section class="section_slide-four">
      <div class="container-fluid">
        <!-- new section html -->
        <h2 data-aos="fade-up">{{this.customer_data.title}}</h2>
        <p class="sub-heading" data-aos="fade-up" v-html="this.customer_data.desc"></p>
        <div class="tabs-wrapper">
          <div>
            <b-card no-body>
              <b-tabs card data-aos="fade-down">
                <b-tab :title="this.customer_data.tabs_data[0].title">
                  <b-card-text>
                    <div class="accordion" role="tablist">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="map">
                            <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <b-card no-body>
                            <b-card-header header-tag="header" role="tab">
                              <b-button block v-b-toggle.kuwait1
                                >{{this.customer_data.tabs_data[0].accordion[0].btn_text}}</b-button
                              >
                            </b-card-header>
                            <b-collapse
                              id="kuwait1"
                              visible
                              accordion="my-accordion"
                              role="tabpanel"
                            >
                              <b-card-body>
                                <div class="scrollWrapper">
                                  <scrollbar :ops="scrollSettings">
                                    <ul>
                                      <li v-for="text in this.customer_data.tabs_data[0].accordion[0].list_data" :key="text">{{text}}</li>
                                    </ul>
                                  </scrollbar>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab :title="this.customer_data.tabs_data[1].title">
                  <b-card-text>
                    <div class="accordion" role="tablist">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="map">
                            <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <b-card no-body>
                            <b-card-header header-tag="header" role="tab">
                              <b-button block v-b-toggle.SAUDIARABIA1
                                >{{this.customer_data.tabs_data[1].accordion[0].btn_text}}</b-button
                              >
                            </b-card-header>
                            <b-collapse
                              id="SAUDIARABIA1"
                              visible
                              accordion="my-accordion"
                              role="tabpanel"
                            >
                              <b-card-body>
                                <div class="scrollWrapper">
                                  <scrollbar :ops="scrollSettings">
                                    <ul>
                                      <li v-for="text in this.customer_data.tabs_data[1].accordion[0].list_data" :key="text" v-html="text"></li>
                                    </ul>
                                  </scrollbar>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab :title="this.customer_data.tabs_data[2].title">
                  <b-card-text>
                    <div class="accordion" role="tablist">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="col-lg-6">
                            <div class="map">
                              <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <b-card no-body>
                            <b-card-header header-tag="header" role="tab">
                              <b-button block v-b-toggle.BAHRAIN1
                                >{{this.customer_data.tabs_data[2].accordion[0].btn_text}}</b-button
                              >
                            </b-card-header>
                            <b-collapse
                              id="BAHRAIN1"
                              visible
                              accordion="my-accordion"
                              role="tabpanel"
                            >
                              <b-card-body>
                                <div class="scrollWrapper">
                                  <scrollbar :ops="scrollSettings">
                                    <ul>
                                      <li v-for="text in this.customer_data.tabs_data[2].accordion[0].list_data" :key="text">{{text}}</li>
                                    </ul>
                                  </scrollbar>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
            <p class="text-right">{{this.customer_data.bheading}}</p> 
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    scrollSettings: Object,
    customer_data:Object
  },
};
</script>

<style lang="scss" scoped></style>
